<template>
  <div class="content">
    <img src='https://preprod.api.defipix.fr/logos/logo_bg_white.png' alt="logo defipix" class="logoDP">  
    <div class="form" v-if="payment">
      <template v-if="payment.state == 'canceled'">
        <h5>Votre paiement à été annulé.</h5>
      </template>
      <template v-else-if="payment.state == 'paid'">
        <h5>Votre paiement à bien été réglé.</h5>
      </template>
      <template v-else>
        <h4>Veuillez patienter, vous allez être redirigé(e)...</h4>
        <p>Si rien ne ce passe, cliquez sur le boutton ci-dessous.</p>
        <!-- <h5>Merci de vérifier l'exactitude des champs suivants</h5>
        <div v-if="payment.payment_method === 1">
            <p>Paiement en 1 fois par carte bleue</p>
            <label for="formAmount" id="labelFormAmount">Montant total du paiement</label>
            <input v-model="payment.amount" type="number" name="formAmount" id="formAmount" disabled>
        </div>
        <div v-else>
            <p>Paiement en 3 fois sans frais</p>
            <p>Première mensualité : {{ firstPayment }}€</p>
            <p>Deuxième mensualité : {{ secondPayment }}€</p>
            <p>Troisième mensualité : {{ lastPayment }}€</p>
            <p>Montant total : {{ payment.amount }}€</p>
        </div>
        <label for="formId" id="labelFormId">identifiant de paiement</label>
        <input v-model="payment.id" type="text" name="formId" id="formId" disabled>
        <label for="formName" id="labelFormAmount">Nom du devis / facture</label>
        <input v-model="payment.name" type="text" name="formName" id="formName" disabled>
        <label for="formCommentary" id="labelFormCommentary">Commentaire</label>
        <input v-model="payment.commentary" type="text" name="formCommentary" id="formCommentary" disabled>
        <label for="formState" id="labelState">État</label>
        <input v-model="payment.state" type="text" name="formState" id="formState" disabled>
        <label for="formMail" id="labelState">E-mail</label>
        <input v-model="payment.email" type="text" name="formMail" id="formMail" disabled> -->
        <div class="button" @click="goPay()">
            <span>Procéder au paiement</span>
        </div>
      </template>
    </div>
    <div v-else class="form">
        <h5>Impossible de génerer votre lien de paiement.<br>veuillez réessayer ulérieurement.<br>Si le problème persiste, contactez-nous.</h5>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  title: "Défipix.fr | Lien de paiement",
  data() {
    return {
      payment: null
    }
  },
  mounted: function () {
    this.getPayment();
  },
  computed: {
    firstPayment: function () {
      return Math.round(Number(this.payment.amount) / 3);
    },
    secondPayment: function () {
      return Math.round(Number(this.payment.amount) / 3);
    },
    lastPayment: function () {
      return Number(this.payment.amount - (this.firstPayment + this.secondPayment));
    },
    amount: function () {
      return `${this.payment.amount}.00`;
    }
  },
  methods: {
    async getPayment() {
      try {
        if (this.$route.query.id) {
          const response = await axios.get(`https://preprod.api.defipix.fr/payment_link/${this.$route.query.id}`);
          this.payment = response.data;
          this.goPay();
        }
      } catch (error) {
        console.error(error);
      }
    },
    goPay() {
      if (this.payment.state == 'paid' || this.payment.state == 'canceled') return;
      let form = document.createElement("form");
      form.setAttribute("method", "post");

      const FormAmount = document.createElement("input");
      FormAmount.setAttribute("type", "hidden");
      FormAmount.setAttribute("name", "amount");
      FormAmount.setAttribute("value", this.amount);
      form.appendChild(FormAmount);

      const FormFreeText = document.createElement("input");
      FormFreeText.setAttribute("type", "hidden");
      FormFreeText.setAttribute("name", "freeText");
      FormFreeText.setAttribute("value", `PaymentLink|${this.payment.id}`);
      form.appendChild(FormFreeText);

      const FormReference = document.createElement("input");
      FormReference.setAttribute("type", "hidden");
      FormReference.setAttribute("name", "reference");
      FormReference.setAttribute("value", this.payment.name);
      form.appendChild(FormReference);

      const FormEmail = document.createElement("input");
      FormEmail.setAttribute("type", "hidden");
      FormEmail.setAttribute("name", "email");
      FormEmail.setAttribute("value", this.payment.email);
      form.appendChild(FormEmail);

      if (this.payment.payment_method === 1) {
        form.setAttribute("action", "https://defipix.fr/paiement/Payment1.php");
        document.body.appendChild(form);
        form.submit();
      } else if (this.payment.payment_method === 3) {
        const FormEcheance1 = document.createElement("input");
        FormEcheance1.setAttribute("type", "hidden");
        FormEcheance1.setAttribute("name", "echeance1");
        FormEcheance1.setAttribute("value", this.firstPayment);
        form.appendChild(FormEcheance1);
        
        const FormEcheance2 = document.createElement("input");
        FormEcheance2.setAttribute("type", "hidden");
        FormEcheance2.setAttribute("name", "echeance2");
        FormEcheance2.setAttribute("value", this.secondPayment);
        form.appendChild(FormEcheance2);
        
        const FormEcheance3 = document.createElement("input");
        FormEcheance3.setAttribute("type", "hidden");
        FormEcheance3.setAttribute("name", "echeance3");
        FormEcheance3.setAttribute("value", this.lastPayment);
        form.appendChild(FormEcheance3);

        form.setAttribute("action", "https://defipix.fr/paiement/Payment3.php");
        document.body.appendChild(form);
        form.submit();
      }
    }
  }
}
</script>

<style scoped>
.logoDP {
  max-width: 15em;
  margin: 0 auto 1em auto;
  display: block;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.form {
  background-color: #25327B;
  width: 30em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2em 3em;
  border-radius: 10px;
  color: #fff;
  text-align: center;
}

.button {
  background-color: #f677c4;
  border-radius: 10px;
  width: fit-content;
  padding: 0.75em 1.5em;
  margin: 1em 0 0 0;
}

.button:hover {
  cursor: pointer;
  transform: scale(1.02);
}
</style>


// WEBPACK FOOTER //
// src/router/PaymentLink.vue